import React from "react";

import { color } from "minimum-ui/tokens";
import styled from "styled-components";

import { Typography } from "../Typography/Typography";

export const BetaBadge: React.FC = () => {
  return (
    <Badge>
      <Typography variant="fieldTitle" color="inherit">
        BETA
      </Typography>
    </Badge>
  );
};

const Badge = styled.span`
  display: inline-block;
  padding: 0.25rem;
  border-radius: 0.25rem;
  color: ${color.purple[400]};
  background: ${color.purple[100]};
  white-space: nowrap;
`;
